import { Component, Vue } from 'vue-property-decorator';

@Component<Title>({})
export default class Title extends Vue {

  // #region @Props
  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion


  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #endregion

  // #region @Watchers
  // #endregion
}
